import { render, staticRenderFns } from "./SitioExport.vue?vue&type=template&id=70cee868"
import script from "./SitioExport.vue?vue&type=script&lang=js"
export * from "./SitioExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports